export var MODULES;
(function (MODULES) {
    MODULES["VMDS"] = "VMDSModule";
    MODULES["VEHICLE_SELECTOR"] = "VehicleSelector";
    MODULES["CAR_CONFIGURATION"] = "CarConfigurationModule";
})(MODULES || (MODULES = {}));
